import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import SvgIcon from '../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { H4, H5, H6 } from '../../../AbstractElements'
import ReactApexChart from 'react-apexcharts'
import { totalSalesData } from '../../../Data/Dashboard/Ecommerce'

export default function TotalSales() {
    return (
        <>
            {totalSalesData.map((item) => (
                <Col xl={3} sm={6} key={item.id}>
                    <Card className="total-sales">
                        <CardBody>
                            <Row>
                                <Col md={8} className="box-col-12 ecommerce-chart-data">
                                    <div className={`d-flex ${item.divClass}`}>
                                        <span><SvgIcon iconId={item.icon} /></span>
                                        <div className="flex-shrink-0">
                                            <H4>{item.rate}</H4>
                                            <H6>{item.title}</H6>
                                            <div className="arrow-chart">
                                                <SvgIcon iconId={item.arrowIcon} />
                                                <H5 className={`font-${item.fontColor}`}>{`${item.percent}%`}</H5>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4} className="p-0 ecommerce-chart">
                                    <div className={item.chartClass} id={item.chartClass}>
                                        <ReactApexChart options={item.chart} series={item.chart.series} type={item.chart.type} height={item.chart.height} />
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </>
    )
}